import { setSelectedSuggestionIndex } from '../actions/internalActions';
import { startSearch, onSearchTextChanged } from '../actions/publicActions';
import datapoints from '../datapoints';
import isSearchBoxEmpty from '../selectors/isSearchBoxEmpty';
import { defaultSearchStore, getStore } from '../store/store';
import { logUsage } from 'owa-analytics';
import { SuggestionKind } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
import { removeSuggestionPillFromSearchBox, removeSuggestionPillFromStore, } from '../actions/internalActions';
export default orchestrator(removeSuggestionPillFromSearchBox, function (actionMessage) {
    var searchStore = getStore();
    var suggestionPillId = actionMessage.suggestionPillId;
    var suggestionPillIndex = searchStore.suggestionPillIds.indexOf(suggestionPillId);
    // Throw if suggestion to remove isn't found in the store.
    if (suggestionPillIndex === -1) {
        throw new Error('removeSuggestionPill action should not be dispatched when the suggestion is not present in the store.');
    }
    // Get actual suggestion from the store.
    var suggestion = searchStore.suggestionPills.get(suggestionPillId);
    // Log CTQ to track suggestion pill removal from the search box.
    logUsage(datapoints.RemoveSuggestionPillAction.datapoint.name, datapoints.RemoveSuggestionPillAction.datapoint.customData(SuggestionKind[suggestion.kind]));
    /**
     * Dispatch removeSuggestionPill mutatorAction to remove suggestion pill
     * from the store. This is done within this orchestrator insteading having
     * an explicit mutator because order matters and it must happen before checking
     * if the search box is empty.
     */
    removeSuggestionPillFromStore(suggestionPillId, suggestionPillIndex);
    // Reset selectedSuggestionIndex since user broke out of arrowing flow.
    setSelectedSuggestionIndex(defaultSearchStore.selectedSuggestionIndex);
    /**
     * After suggestion pill is removed, check if search box is empty. If search
     * box is not empty, dispatch a startSearch action to initiate search.
     *
     * If search box is empty, update the search box text to zero input.
     */
    if (!isSearchBoxEmpty()) {
        startSearch('NonUserAction');
    }
    else {
        onSearchTextChanged('');
    }
});
//# sourceMappingURL=removeSuggestionPillFromSearchBoxOrchestrator.js.map